import React from 'react'
import BannerImage from "../assets/BannerImage.jpg";
import { FaRegAddressCard } from "react-icons/fa";
import { BsTelephone } from "react-icons/bs";
import { IoMdMailUnread } from "react-icons/io";
import GetInTouch from '../Components/GetInTouch';
import Stats from '../Components/Stats';

import ContactForm from '../Components/ContactForm';

const Contactus = () => {


  return (
    <>
        <div className='relative -z-20'>
            <div className="absolute w-full h-[300px]">
                <img src={BannerImage} alt="WhyChooseUs" className="object-cover w-full h-[300px] opacity-95" />
            </div>
            <div className="relative flex  bg-gray-800 opacity-55">
                <div className="flex justify-start mx-12 items-center leading-8 w-full h-[300px]">
                    <h1 className=" font-bold text-5xl md:text-5xl text-white">Contact Us</h1>
                </div>
            </div>
       </div>

       <div className="mb-32">
  <div id="map" className="relative h-[300px] overflow-hidden bg-cover bg-[50%] bg-no-repeat">
    <iframe title='content'
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11672.945750644447!2d-122.42107853750231!3d37.7730507907087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80858070cc2fbd55%3A0xa71491d736f62d5c!2sGolden%20Gate%20Bridge!5e0!3m2!1sen!2sus!4v1619524992238!5m2!1sen!2sus"
      width="100%" height="480" style={{border:0}} ></iframe>
  </div>
  <div className="container px-6 md:px-12">
    <div
      className="block rounded-lg bg-[hsla(0,0%,100%,0.8)] px-6 py-12 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)]  md:py-16 md:px-12 -mt-[100px] backdrop-blur-[30px] border border-gray-300">
      <div className="flex flex-wrap">
        <div className="w-full shrink-0 grow-0 basis-auto lg:w-7/12">
          <div className="flex flex-wrap">
            <div className="mb-12 w-full shrink-0 grow-0 basis-auto md:w-6/12 md:px-3 lg:w-full lg:px-6 xl:w-6/12">
              <div className="flex items-start">
                <div className="shrink-0">
                  <div className="inline-block rounded-full text-white bg-yellow-500 p-4 text-primary">
                    <IoMdMailUnread size={40} />
                  </div>
                </div>
                <div className="ml-6 grow">
                  <p className="mb-2 font-bold ">
                    Email 
                  </p>
                  <p className="text-sm text-neutral-500">
                    ozwidecover@gmail.com
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-12 w-full shrink-0 grow-0 basis-auto md:w-6/12 md:px-3 lg:w-full lg:px-6 xl:w-6/12">
              <div className="flex items-start">
                <div className="srink-0">
                  <div className="inline-block rounded-full text-white bg-yellow-500 p-4 text-primary">
                    <FaRegAddressCard size={40} />
                  </div>
                </div>
                <div className="ml-6 grow">
                  <p className="mb-2 font-bold ">
                    Address
                  </p>
                  <p className="text-sm text-neutral-500">
                    PO Box 2354, <br />
                        Sunnybank Hills <br />
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-12 w-full shrink-0 grow-0 basis-auto md:mb-0 md:w-6/12 md:px-3 lg:mb-12 lg:w-full lg:px-6 xl:w-6/12">
              <div className="align-start flex">
                <div className="shrink-0">
                  <div className="inline-block rounded-full text-white bg-yellow-500 p-4 text-primary">
                    <BsTelephone size={40} />
                  </div>
                </div>
                <div className="ml-6 grow">
                  <p className="mb-2 font-bold ">Phone no</p>
                  <p className="text-neutral-500"> (+61) 452 322 420
                  </p>
                </div>
              </div>
            </div>
            
          </div>
        </div>
        <div className="mb-12 w-full shrink-0 grow-0 basis-auto md:px-3 lg:mb-0 lg:w-5/12 lg:px-6">
          <ContactForm />
        </div>
        
      </div>
    </div>
  </div>
      </div>
      <Stats />
      <GetInTouch />
    </>
  )
}

export default Contactus
